import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '@els/els-react--modal';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { RxSocketUrls } from '@Constants/CommonConstants';
import RxSocket from '@Services/RxSocket';
import SocketBroker from '@Services/SocketBroker';
import { typeOfReencryptionNotifyModal } from './ReencryptionNotifyModalConstants';

import './ReencryptionNotifyModal.custom.scss';

function ReencryptionNotifyModal() {
  const [text, setText] = useState(' ');
  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    let unregister = RxSocket.onConnect(() => getReEncryptionStatus(statusHandler));
    let unsubscribe;
    const closeConnection = () => {
      if (unsubscribe) {
        unsubscribe();
        unsubscribe = null;
      }
      if (unregister) {
        unregister();
        unregister = null;
      }
    };

    const statusHandler = (data) => {
      Logger.info('ReEncryption Status - WS message', data);

      // take numbers from response and paste in message

      setText(`Processing ${data.payload.completeCount} of ${data.payload.totalCount}.`);

      // close modal and unsubscribe if runningState
      if (data.payload.runningState === 'STOPPED') {
        dispatch(
          closeDialog({
            id: typeOfReencryptionNotifyModal,
          })
        );
        closeConnection();
      }
    };

    const getReEncryptionStatus = (statusHandlerFunc) => {
      // Subscribe to WS
      unsubscribe = SocketBroker.observe(RxSocketUrls.ChannelsUrls.ReEncryption.status, statusHandlerFunc);

      Logger.info('ReEncryption Status - WS send');

      // Send WS
      SocketBroker.send(
        { send: RxSocketUrls.ChannelsUrls.ReEncryption.subscribe },
        {
          params: {},
        }
      );
    };
    return () => {
      // eslint-disable-next-line no-use-before-define
      closeConnection();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeWindow = () => {
    dispatch(
      closeDialog({
        id: typeOfReencryptionNotifyModal,
      })
    );
  };
  return (
    <Modal
      onClose={closeWindow}
      type="secondary"
      className="reencryption-notify-modal"
      id="reencryption-notify"
      shouldPreventClickOverlayToClose>
      <div>
        <h4>Authentication</h4>
        <section className="rx-reencryption-notify-modal-content">
          Due to recent changes, we need to prepare your Synthesis Project data.
          <br />
          {text}
        </section>
      </div>
    </Modal>
  );
}

export default ReencryptionNotifyModal;
